import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import productReducer from './slices/product';
import elementReducer from './slices/element';
import magictypeReducer from './slices/magictype';
import cardReducer from './slices/card';
import rarityReducer from './slices/rarity';
import spellReducer from './slices/spell';
import characterReducer from './slices/character';
import appointReducer from './slices/appoint';
import slotReducer from './slices/slot';
import DressCode from './slices/DressCode';
import RegistrationForm from './slices/RegistrationForm';
import CheckInfo from './slices/CheckInfo';
import checkedReportsSlice from './slices/checkedReportsSlice';
import hospitalAllCheckedReportsSlice from './slices/hospitalAllCheckedReportsSlice';
import RadiologistAllReportsSlice from './slices/RadiologistAllReportsSlice';
import radiologistAllCheckedReportsSlice from './slices/radiologistAllCheckedReportsSlice';
import ReportPending from './slices/ReportPending';
import ReportApproved from './slices/ReportApproved';
import inventoryManagementSlice from './slices/inventoryManagement';
import userManagementSlice from './slices/userManagement';
import orderManagementSlice from './slices/orderManagement';
import networkSlice from './slices/network';
import storageSlice from './slices/storage';
import brandSlice from './slices/brand';
import categorySlice from './slices/category';
import modelSlice from './slices/model';
import dropdownSlice from './slices/settings';
import unlockcodeSlice from './slices/unlockcode';
import dispatchManagementSlice from './slices/dispatchManagement';
import testerManagementSlice from './slices/testerManagement';
import shippedItemsManagementSlice from './slices/shippedItemsManagement';
import returnItemsManagementSlice from './slices/returnItemsManagement';
import seriesSlice from './slices/series';
import colorSlice from './slices/color';

const rootPersistConfig = {
  key: 'root',
  storage,
  // keyPrefix: 'redux-',
  // whitelist: [],
};


const rootReducer = combineReducers({
  element: elementReducer,
  magictype: magictypeReducer,
  card: cardReducer,
  rarity: rarityReducer,
  spell: spellReducer,
  character: characterReducer,
  product: productReducer,
  appoint: appointReducer,
  slot: slotReducer,
  dresscode: DressCode,
  registrationForm: RegistrationForm,
  checkInfo: CheckInfo,
  report: ReportPending,
  reportApproved: ReportApproved,
  checkedReports: checkedReportsSlice,
  hospitalAllCheckedReports: hospitalAllCheckedReportsSlice,
  radiologistReports: RadiologistAllReportsSlice,
  radiologistAllCheckedReports: radiologistAllCheckedReportsSlice,
  inventoryManagement: inventoryManagementSlice,
  userManagement: userManagementSlice,
  orderManagement: orderManagementSlice,
  network: networkSlice,
  storage: storageSlice,
  brand: brandSlice,
  series: seriesSlice,
  color: colorSlice,
  category: categorySlice,
  model: modelSlice,
  dropdown: dropdownSlice,
  unlockcode: unlockcodeSlice,
  testerManagement: testerManagementSlice,
  dispatchManagement: dispatchManagementSlice,
  shippedItemsManagement: shippedItemsManagementSlice,
  returnItemsManagement: returnItemsManagementSlice,
});

export { rootPersistConfig, rootReducer };
